/**
 * Endpoint methods related to Courses Feature
*/

import API from "./Api";

export default {
  /**
   * Gets all the Courses related to the logged-In Instance
   */
  async getAll() {

    return API.get("/courses/getallown", "COOKIE_TOKEN_SESSION");
  },
};
